<template>
  <mu-bottom-nav :value.sync="shift">
    <mu-bottom-nav-item value="index"
                        title="首页"
                        to="/index"
                        icon="home"></mu-bottom-nav-item>
    <mu-bottom-nav-item value="hot"
                        title="热销"
                        to="/hot"
                        icon="whatshot"></mu-bottom-nav-item>
<!--    <mu-bottom-nav-item value="follow"-->
<!--                        title="随访"-->
<!--                        to="/follow"-->
<!--                        icon="add_box"></mu-bottom-nav-item>-->
    <mu-bottom-nav-item value="my"
                        title="我的"
                        to="/my"
                        icon="person"></mu-bottom-nav-item>
  </mu-bottom-nav>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return{
      shift: this.$route.path.substring(1),
    }
  },
  watch: {
    '$route'(to) {
      this.shift = to.path.substring(1);
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.mu-bottom-nav{
  width: 100%;
  position: fixed;
  bottom: 0;
  box-shadow: 0px -5px 7px 0px rgba(239, 239, 239, 0.75);
}
</style>
